import React from 'react';
import "./AppBox.css";
import cloudImg from "../assests/cloudy.png";

export default function InfoBox(props) {
  return (
    <>
      <div className="image-temp-box">
                <img src={cloudImg} alt="not foutn" />
                <h1>{props.temperature}°C</h1>
                <h2>
                  {props.cityName} | {props.countryName}
                </h2>
              </div>
              <div className="more-info-box">
                <div className="weather-box">
                  <div className="icon">
                    <i className="fa-solid fa-droplet"></i>
                  </div>
                  <div className="data">
                    {props.humidity}% <br /> Humidity
                  </div>
                </div>
                <div className="wind-box">
                  <div className="icon">
                    <i className="fa-solid fa-wind"></i>
                  </div>
                  <div className="data">
                    {props.windSpeed} km/hr <br /> Wind
                  </div>
                </div>
              </div>
              <br />
              <div className="more-info-box">
                <div className="weather-box">
                  <div className="icon">
                    <i className="fa-solid fa-eye"></i>
                  </div>
                  <div className="data">
                    {props.visibility} mi <br /> Visibility
                  </div>
                </div>
                <div className="wind-box">
                  <div className="icon">
                    <i className="fa-solid fa-water"></i>
                  </div>
                  <div className="data">
                    {props.description} <br /> Description
                  </div>
                </div>
              </div>
    </>
  )
}
